import angular from 'angular';
import insuranceFactFindAnswer from './insuranceFactFindAnswer';

export default angular
  .module('components.insuranceFactFindAnswer', [])
  .component('insuranceFactFindAnswer', insuranceFactFindAnswer).name;
